import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import LandingPage from './pages/home/LandingPage';
import ListUsers from './pages/user/ListUsers';
import AuthCallback from "./pages/home/AuthCallback";
import ListAdvertisements from "./pages/advertisements/ListAdvertisements";
import CreateStories from "./pages/stories/CreateStories";
import ListStories from "./pages/stories/ListStories";
import CreateTrails from "./pages/trails/CreateTrails";
import ListTrails from "./pages/trails/ListTrails";
import CreateAdvertisements from "./pages/advertisements/CreateAdvertisements";
import Contact from "./pages/contact/Contact";
import Footer from "./components/Footer";

const routing = () => (
    <Router>
        <Header />
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/advertisements/create" element={<CreateAdvertisements />} />
            <Route path="/advertisements/list" element={<ListAdvertisements />} />
            <Route path="/advertisements/details/:advertisementId" element={<CreateAdvertisements />} />
            <Route path="/stories/create" element={<CreateStories />} />
            <Route path="/stories/list" element={<ListStories />} />
            <Route path="/stories/details/:storyId" element={<CreateStories />} />
            <Route path="/trails/create" element={<CreateTrails />} />
            <Route path="/trails/list" element={<ListTrails />} />
            <Route path="/trails/details/:trailId" element={<CreateTrails />} />
            <Route path="/users/list" element={<ListUsers />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
    </Router>
);

export default routing
